import api from './api';

export const campaignService = {
  getCampaigns: (limit = 50) => api.getCampaigns(limit),
  getPublicCampaigns: (limit = 50) => api.getPublicCampaigns(limit),
  getUserCampaigns: () => api.getUserCampaigns(),
  getCampaign: (id) => api.getCampaign(id),
  createCampaign: (campaignData) => api.createCampaign(campaignData),
  updateCampaign: (id, campaignData) => api.updateCampaign(id, campaignData),
  cancelCampaign: (id) => api.cancelCampaign(id),
  deleteCampaign: (id) => api.deleteCampaign(id),
  recordCampaignView: (id) => api.recordCampaignView(id),
  getCampaignStats: (id) => api.getCampaignStats(id)
};

export default campaignService;